import {
  Select,
  SelectContent,
  SelectGroup,
  SelectTrigger,
  SelectItem,
} from '@e2n/ui';
import {
  getWiederholungStringFromTerminWiederholungsIntervall,
  TerminWeekdayOccurrence,
  TerminWiederholungsIntervall,
} from '@/domain/termine/shared/types';
import { useCreateTermineFormContext } from '@/domain/termine/features/CreateTermin/shared/useCreateTermineFormContext';

const validIntervals = Object.values(TerminWiederholungsIntervall);

function isTerminWiederholungsIntervall(
  value: string,
): value is TerminWiederholungsIntervall {
  return validIntervals.some((interval) => interval === value);
}

export default function IndividualRepetitionInterval({
  value,
  onChange,
}: {
  value: TerminWiederholungsIntervall;
  onChange: (value: TerminWiederholungsIntervall) => void;
}) {
  const { form } = useCreateTermineFormContext();

  return (
    <form.Subscribe selector={(state) => state.values.wochentagAuftreten}>
      {(selectedWeekdayOccurrence) => {
        const handleMonthOrYearInterval = () => {
          form.setFieldValue('wochentagAuswahl', []);
          if (!selectedWeekdayOccurrence) {
            form.setFieldValue(
              'wochentagAuftreten',
              TerminWeekdayOccurrence.FIXER_TAG,
            );
          }
        };

        const intervalHandlers: Record<
          TerminWiederholungsIntervall,
          () => void
        > = {
          [TerminWiederholungsIntervall.TAG]: () => {
            form.setFieldValue('wochentagAuftreten', undefined);
            form.setFieldValue('wochentagAuswahl', []);
          },
          [TerminWiederholungsIntervall.WOCHE]: () => {
            form.setFieldValue('wochentagAuftreten', undefined);
          },
          [TerminWiederholungsIntervall.MONAT]: handleMonthOrYearInterval,
          [TerminWiederholungsIntervall.JAHR]: handleMonthOrYearInterval,
        };

        function handleIntervalChange(selectedInterval: string) {
          if (!isTerminWiederholungsIntervall(selectedInterval)) {
            return;
          }
          onChange(selectedInterval);
          intervalHandlers[selectedInterval]();
        }

        return (
          <div className="pb-3 h-10">
            <Select value={value} onValueChange={handleIntervalChange}>
              <SelectTrigger className="border-neutrals-300 w-full">
                <div>
                  {getWiederholungStringFromTerminWiederholungsIntervall(value)}
                </div>
              </SelectTrigger>
              <SelectContent className="border-none overflow-visible">
                <SelectGroup>
                  {Object.values(TerminWiederholungsIntervall).map(
                    (enumValue) => (
                      <SelectItem key={enumValue} value={enumValue}>
                        {getWiederholungStringFromTerminWiederholungsIntervall(
                          enumValue,
                        )}
                      </SelectItem>
                    ),
                  )}
                </SelectGroup>
              </SelectContent>
            </Select>
          </div>
        );
      }}
    </form.Subscribe>
  );
}
